var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"company"},[_c('Header',{attrs:{"user":_vm.user}}),_c('main',{staticClass:"main",class:{ 'expand-main' : _vm.isMenuCollapse }},[_c(_vm.companiesTabComponent,{tag:"component",attrs:{"selectedClientId":_vm.selectedClientId,"selectedClientName":_vm.selectedClientName}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }